const compileFields = (fieldsObject, requiredFieldsObject = {}) => {
  let fields = [];
  Object.entries(fieldsObject).forEach(([key, value]) => {
    fields.push({
      slug: key,
      text: value,
      required: key in requiredFieldsObject,
    });
  });
  return fields;
};

export { compileFields };
